// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";        // <-- your main component
import "./styles.css";          // <-- global styles (optional)

// Grab the <div id="root"></div> from public/index.html
const container = document.getElementById("root");
const root = createRoot(container);

// Render the full application
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
